import React from "react"
import { connect } from "react-redux"

class Recorder extends React.PureComponent {
    state = {
        recording: false,
        paused: false,
        recorded: false,
        audioCheckError: "",
    }

    init = () =>
        navigator.mediaDevices.getUserMedia({ audio: true, video: false }).then(stream => {
            let streamSettings, meter, tracks;
            if (this.props.analysis) {
                this.setState({ analysis: { total: 0, clip: 0, normal: 0, silent: 0 }})
                tracks = stream.getAudioTracks();
                if (tracks.length > 0) { 
                    streamSettings = tracks[0].getSettings();
                    streamSettings["label"] = tracks[0].label;
                }
                meter = this.analysis(stream, this)
            }

            this.mediaRecorder = new MediaRecorder(stream)
            const audioChunks = []

            this.mediaRecorder.addEventListener("dataavailable", event => {
                audioChunks.push(event.data)
            })

            this.mediaRecorder.addEventListener("stop", () => {
                const audioBlob = new Blob(audioChunks, { type: audioChunks[0].type })
                const audioUrl = URL.createObjectURL(audioBlob)
                if (this.props.onChange) {
                    this.props.onChange(audioUrl, audioBlob, streamSettings, this.state.analysis)
                }
                this.setState({ recorded: true, recording: false })
                stream.getTracks().forEach(function (track) {
                    track.stop()
                })

                if (meter) {
                    meter.disconnect();
                    meter.onaudioprocess = null
                }
            })
        })

    analysis = (stream) => {
        let clipLevel = 80;
        let silentLevel = 10;

        let audioContext = new(window.AudioContext || window.webkitAudioContext)();
        let analyser = audioContext.createAnalyser();
        let microphone = audioContext.createMediaStreamSource(stream);
        let javascriptNode = audioContext.createScriptProcessor(2048, 1, 1);

        analyser.smoothingTimeConstant = 0.8;
        analyser.fftSize = 1024;

        microphone.connect(analyser);
        analyser.connect(javascriptNode);
        javascriptNode.connect(audioContext.destination);

        javascriptNode.onaudioprocess = () => {
            let array = new Uint8Array(analyser.frequencyBinCount);
            analyser.getByteFrequencyData(array);
            let values = 0;
            let astatus = "";

            let length = array.length;
            for (var i = 0; i < length; i++) {
                values += array[i];
            }

            let average = values / length;

            if (Math.abs(average) > clipLevel) { astatus = "clip"; }
            else if (Math.abs(average) < silentLevel) { astatus = "silent"; }
            else { astatus = "normal"; }
            
            this.setState(state => ({ analysis: {
                ...state.analysis,
                total: state.analysis.total += 1,
                clip: astatus === "clip" ? state.analysis.clip += 1 : state.analysis.clip,
                silent: astatus === "silent" ? state.analysis.silent += 1 : state.analysis.silent,
                normal: astatus === "normal" ? state.analysis.normal += 1 : state.analysis.normal,
            }}))
        }
        return javascriptNode;
    }

    start = () => {
        this.init()
            .then(() => {
                this.setState({ recorded: false, recording: true, audioCheckError: "" })
                if (this.props.onStart) { this.props.onStart() }
                this.mediaRecorder.start()
            })
            .catch(error => {
                let msg = ""
                if (error.name === "NotAllowedError") {
                    msg = "unable to access a microphone"
                } else if (error.name === "NotFoundError") {
                    msg = "unable to find a microphone"
                } else if (error.name === "ConstraintNotSatisfiedError") {
                    msg = "Audio hardware issue: " + error.constraintName
                } else {
                    msg = "Unknown error: " + error
                }
                this.props.eventHandler.onError(msg)
                this.setState({ audioCheckError: msg })
            })
    }

    pause = () => {
        if (this.mediaRecorder) {
            this.setState({ paused: true })
            this.mediaRecorder.pause()
        }
    }

    resume = () => {
        if (this.mediaRecorder) {
            this.setState({ paused: false })
            this.mediaRecorder.resume()
        }
    }

    stop = () => {
        if (this.mediaRecorder) {
            this.mediaRecorder.stop()
            if (this.props.onStop) { this.props.onStop() }
        }
    }


    componentDidUpdate(prevProps) {
        if (prevProps.startAudioTest !== this.props.startAudioTest) {
          console.log(this.props.startAudioTest, "audioTest")
          const {startAudioTest} = this.props
          if (startAudioTest === true) {
            this.start()
          }
          if (startAudioTest === false) {
            this.stop()
          }
          if (startAudioTest === 'pause') {
            this.pause()
          }
          if (startAudioTest === 'resume') {
            this.resume()
          }
        }
      }

    render() {
        return (
            <div></div>
        )
    }
}

const mapStateToProps = state => {
    return {
        startAudioTest: state.checks.startAudioTest
    }
}


export default connect(mapStateToProps)(Recorder)
